import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Box } from '@mui/system'
import ModalContainer from '../../../../../Modals/ModalContainer'
import { hideModal, showSuccesNotification, showErrorNotification } from '../../../../../../redux/actions'
import { MUIFormTextInput } from '../../../../../@Common/Form/TextInput/FormTextInput'
import { Button, Grid, Radio, RadioGroup, FormControlLabel, FormControl } from '@mui/material'

function ListingIntegrationModal({
    partnerListing,
    customer,
    deleteListingCustomer,
    searchMarketplaceCustomer,
    saveListingCustomer,
    createListingCustomer,
    refetchPartnerListingIntegrations,
}) {
    const dispatch = useDispatch()
    const defaultSecondaryAction = { label: 'Close', onClick: () => dispatch(hideModal()) }
    const defaultNetSuiteCustomerData = { name: '', customerId: '', mappedName: '', mappingExists: false }
    const [processing, setProcessing] = useState(false)
    const [secondaryAction, setSecondaryAction] = useState(defaultSecondaryAction)
    const [showCustomerSearch, setShowCustomerSearch] = useState(false)
    const [showSearchResults, setShowSearchResults] = useState(false)
    const [showDeleteCustomer, setShowDeleteCustomer] = useState(false)
    const [searchCustomerError, setSearchCustomerError] = useState({ show: false, error: '' })
    const [listingCustomer, setlistingCustomer] = useState(customer)
    const [netSuiteCustomer, setNetSuiteCustomer] = useState(defaultNetSuiteCustomerData)
    const [netsuiteCustomerId, setNetsuiteCustomerId] = useState(null)
    const [selectedOption, setSelectedOption] = useState('createNewCustomer'); // Default selection

    const handleOptionChange = (event) => {
        setSelectedOption(event.target.value);
    };

    const getCustomerSearchResults = () => {
        setProcessing(true)
        searchMarketplaceCustomer(netsuiteCustomerId).then((resp) => {
            setNetSuiteCustomer(resp.data)
            setShowSearchResults(false)
            setSearchCustomerError({ show: true, error: '' })

            if (resp.isError && resp.error?.status === 404) setSearchCustomerError({ show: true, error: 'NetSuite customer not found.' })
            else if (resp.isError && resp.error?.status === 500) setSearchCustomerError({ show: true, error: 'NetSuite service encounted an error when searching for the customer.' })
            else if (resp.isError) setSearchCustomerError({ show: true, error: 'Encounted an error while searching for the netsuite customer.' })
            else if (resp.data?.isError) setSearchCustomerError({ show: true, error: resp.data.error })
            else if (resp.data?.mappingExists) setSearchCustomerError({ show: true, error: 'This customer record is already linked to ' + resp.data.mappedName })
            else setShowSearchResults(true)

            setProcessing(false)
        }).catch((error) => {
            console.error('Search failed:', error)
        })
            .finally(() => {
                setProcessing(false)
            })
    }

    const createCustomer = () => {
        setProcessing(true)
        let newCustomer = {
            listingId: partnerListing.id,
            name: partnerListing.name,
            partnerId: partnerListing.partnerId,
            partnerName: partnerListing.partnerName,
        }
        setlistingCustomer(newCustomer)
        createListingCustomer(newCustomer).then(() => {
            refetchPartnerListingIntegrations()
            dispatch(hideModal())
        }).catch((error) => {
            console.error('Save failed:', error)
        })
            .finally(() => {
                setShowCustomerSearch(false)
                setProcessing(false)
            })
    }

    const saveCustomer = () => {
        setProcessing(true)
        let updatedCustomer = {
            listingId: partnerListing.id,
            netSuiteCustomerId: netSuiteCustomer.customerId,
            name: netSuiteCustomer.name,
            partnerId: partnerListing.partnerId,
            partnerName: partnerListing.partnerName,
        }
        setlistingCustomer(updatedCustomer)
        saveListingCustomer(updatedCustomer).then(() => {
            refetchPartnerListingIntegrations()
            dispatch(hideModal())
        }).catch((error) => {
            console.error('Save failed:', error)
        })
            .finally(() => {
                setShowCustomerSearch(false)
                setProcessing(false)
            })
    }

    const deleteCustomer = () => {
        deleteListingCustomer(partnerListing.id).then(() => {
            refetchPartnerListingIntegrations()
            dispatch(showSuccesNotification('NetSuite connection successfully removed.'))
            dispatch(hideModal())
        }).catch((error) => {
            dispatch(showErrorNotification('Something went wrong removing the NetSuite connection. Please try again later.'))
            console.error('Delete failed:', error)
        })
            .finally(() => {
                setShowDeleteCustomer(false)
            })
    }

    const hideModalFn = (event, reason) => {
        if (reason === 'backdropClick' && modal) {
            return
        }
        dispatch(hideModal())
    }

    useEffect(() => {
        if (showDeleteCustomer || showCustomerSearch) {
            setSecondaryAction(null)
        }
        else {
            setSecondaryAction(defaultSecondaryAction)
        }
    }, [showCustomerSearch, showDeleteCustomer])

    useEffect(() => {
        if (!listingCustomer) {
            setShowCustomerSearch(true)
        } else {
            setShowDeleteCustomer(true)
        }
    }, [])

    return (
        <>
            <ModalContainer
                title={"Integrate NetSuite"}
                maxWidth="sm"
                fullWidth="true"
                modal
                onClose={hideModalFn}
                processing={processing}
                actions={{
                    secondaryAction: secondaryAction,
                }}
            >
                {!showSearchResults && !showDeleteCustomer &&
                    <FormControl component="fieldset" sx={{ mb: 3 }}>
                        <RadioGroup
                            value={selectedOption}
                            onChange={handleOptionChange}
                        >
                            <FormControlLabel
                                sx={{ marginBottom: '15px' }}
                                value="createNewCustomer"
                                control={<Radio />}
                                label="Create a new customer record"
                            />
                            <FormControlLabel
                                value="selectExistingCustomer"
                                control={<Radio />}
                                label="Select an existing customer record"
                            />
                        </RadioGroup>
                    </FormControl>
                }
                {showCustomerSearch && selectedOption === 'selectExistingCustomer' &&
                    <Box>
                        {!showSearchResults ?
                            <Box sx={{ paddingLeft: '30px' }}>
                                <Box>
                                    <MUIFormTextInput
                                        name="netsuiteCustomerId"
                                        label="Customer ID"
                                        gxid="netsuiteCustomerId"
                                        value={netsuiteCustomerId}
                                        onChange={(e) => setNetsuiteCustomerId(e)}
                                    />
                                </Box>
                                {searchCustomerError.show &&
                                    <p style={{ color: '#bd2326', fontSize: '.875rem', marginTop: '0.25rem' }}>
                                        {searchCustomerError.error}
                                    </p>
                                }
                                <Grid container sx={{ marginTop: '10px' }} justifyContent="flex-end" spacing={2}>
                                    <Grid xs={2}>
                                        <Button
                                            variant="text"
                                            onClick={() => { dispatch(hideModal()) }}
                                            label={'Cancel'}
                                            style={{
                                                minHeight: '36px',
                                                minWidth: '64px',
                                                marginLeft: '10px',
                                            }}
                                        >
                                            Cancel
                                        </Button>
                                    </Grid>
                                    <Grid xs={2}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={() => getCustomerSearchResults()}
                                            label={'Search'}
                                            style={{
                                                minHeight: '36px',
                                                minWidth: '64px',
                                            }}
                                        >
                                            Search
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Box>
                            :
                            <>
                                <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                                    <Box sx={{ fontWeight: 'bold', marginRight: '10px' }}>Customer Record Name:</Box>
                                    <Box>{netSuiteCustomer?.name}</Box>
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                                    <Box sx={{ fontWeight: 'bold', marginRight: '10px' }}>Customer Record Internal ID:</Box>
                                    <Box>{netSuiteCustomer?.customerId}</Box>
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                                    <Box>Click save to link NetSuite to this listing. This will link this listing to the customer record in NetSuite for reporting and invoicing purposes.</Box>
                                </Box>
                                <Grid container sx={{ marginTop: '10px' }} justifyContent="flex-end" spacing={2}>
                                    <Grid item xs={2}>
                                        <Button
                                            variant="text"
                                            onClick={() => { setShowSearchResults(false) }}
                                            label={'Cancel'}
                                            style={{
                                                minHeight: '36px',
                                                minWidth: '64px',
                                            }}
                                        >
                                            Cancel
                                        </Button>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={() => saveCustomer()}
                                            label={'Save'}
                                            style={{
                                                minHeight: '36px',
                                            }}
                                        >
                                            Save
                                        </Button>
                                    </Grid>
                                </Grid>
                            </>
                        }
                    </Box>
                }
                {showDeleteCustomer &&
                    <Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                            <Box sx={{ fontWeight: 'bold', marginRight: '10px' }}>Listing Name:</Box>
                            <Box>{partnerListing?.name}</Box>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                            <Box sx={{ fontWeight: 'bold', marginRight: '10px' }}>NetSuite Customer ID:</Box>
                            <Box>{listingCustomer?.netSuiteCustomerId}</Box>
                        </Box>
                        <Box>Are you sure you want to delete the link to the NetSuite? Deleting the listings link to the customer record in NetSuite will affect reporting and invoicing.</Box>
                        <Grid container sx={{ marginTop: '10px' }} justifyContent="flex-end" spacing={2}>
                            <Grid item xs={2}>
                                <Button
                                    variant="text"
                                    onClick={() => { setShowDeleteCustomer(false); dispatch(hideModal()) }}
                                    label={'Cancel'}
                                    style={{
                                        minHeight: '36px',
                                        minWidth: '64px',
                                    }}
                                >
                                    Cancel
                                </Button>
                            </Grid>
                            <Grid item xs={2}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => deleteCustomer()}
                                    label={'Search'}
                                    style={{
                                        minHeight: '36px',
                                    }}
                                >
                                    Delete
                                </Button>
                            </Grid>
                        </Grid>
                    </Box>
                }
                {
                    selectedOption === 'createNewCustomer' && !showDeleteCustomer &&
                    <Grid container sx={{ marginTop: '10px' }} justifyContent="flex-end" spacing={2}>
                        <Grid xs={2}>
                            <Button
                                variant="text"
                                onClick={() => { dispatch(hideModal()) }}
                                label={'Cancel'}
                                style={{
                                    minHeight: '36px',
                                    minWidth: '64px',
                                    marginLeft: '10px',
                                }}
                            >
                                Cancel
                            </Button>
                        </Grid>
                        <Grid xs={2}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => createCustomer()}
                                label={'Search'}
                                style={{
                                    minHeight: '36px',
                                    minWidth: '64px',
                                }}
                            >
                                Create
                            </Button>
                        </Grid>
                    </Grid>
                }
            </ModalContainer >
        </>
    )
}

export default ListingIntegrationModal    